function LegendItem({ color, label }) {
  return (
    <div className="sensor-legend__item" style={{ color }}>
      <span className="sensor-legend__bar" style={{ backgroundColor: color }} />
      {label}
    </div>
  )
}

export { LegendItem }
export default LegendItem
